module.exports = __webpack_public_path__ + "img/r1c2.d48f13bb.jpg";